/**
 * «Незакрытый прогон инструмента» — чтобы возврат в раздел не терял работу.
 *
 * Жалоба владельца 2026-07-24: сгенерировал фото тренда, ушёл на другую
 * страницу, вернулся в Тренды — виджет стандартный, хотя job жив (клик по той
 * же карточке открывал историю). Причина: tool-режим держится ПИНОМ карточки,
 * а пин привязан к модели — в чужом разделе применяется своя модель и
 * mismatch-детектор снимает пин как чужой. Job при этом переживает всё
 * (usePipelineFlow хранит его id в sessionStorage по слагу шаблона).
 *
 * Здесь — недостающее звено: последний ОТКРЫТЫЙ лендинг инструмента на каждой
 * странице. Возврат в раздел без карточки в адресе → если по её пайплайну
 * ещё жив job, страница возвращает юзера на тот же лендинг (replace).
 *
 * Явное закрытие крестиком чистить не нужно: оно сбрасывает job
 * (GenerateToolMode → handlePipeReset), а без job восстановление не
 * срабатывает — «закрыл» остаётся закрытым.
 */
import { pipelineJobStorageKey } from '../../generate/hooks/usePipelineFlow'

const KEY = 'umnik.active_tool_run'

export interface ActiveToolRun {
	/** Раздел, где открыт инструмент ('image' | 'video' | 'trends'). */
	page: string
	/** Полный путь лендинга — восстанавливаем ровно его (с контекстом витрины). */
	path: string
	/** Слаг ШАБЛОНА пайплайна: по нему проверяем, жив ли job. */
	pipelineSlug: string
}

function readAll(): ActiveToolRun[] {
	try {
		const raw = sessionStorage.getItem(KEY)
		return raw ? (JSON.parse(raw) as ActiveToolRun[]) : []
	} catch {
		return []
	}
}

/** Запомнить открытый лендинг пайплайн-карточки (по одному на раздел). */
export function rememberToolRun(run: ActiveToolRun): void {
	try {
		const rest = readAll().filter((r) => r.page !== run.page)
		sessionStorage.setItem(KEY, JSON.stringify([...rest, run]))
	} catch {
		/* quota — восстановление просто не сработает, поведение как раньше */
	}
}

/**
 * Куда вернуть юзера на этой странице, если работа не закончена.
 * null — незакрытых прогонов нет (job сброшен крестиком или его не было).
 */
export function pendingToolRunPath(page: string): string | null {
	const run = readAll().find((r) => r.page === page)
	if (!run?.pipelineSlug || !run.path) return null
	try {
		return sessionStorage.getItem(pipelineJobStorageKey(run.pipelineSlug)) ? run.path : null
	} catch {
		return null
	}
}
